export * from 'utils/bolt/index.js';

let currentShowtimesData = {};

export function setActiveShowtimesDataForMovie(movie) {
	currentShowtimesData = {
		movieId: movie?.showtimesId,
		bg: { desktop: { asset: movie?.onesheet?.url } },
		rules: { hub: { name: 'focus_features_hub', parameters: [__REGION__, movie?.slug] } },
	};
	if (movie.showtimesQuickFilters) {
		const formats = movie.showtimesQuickFilters.formatOptions && sortQuickFiltersFormat(movie.showtimesQuickFilters.formatOptions);
		const hasFormats = formats && formats.length > 0;
		currentShowtimesData.quickFilters = {
			visibleDesktop: hasFormats,
			visibleMobile: hasFormats,
			title: movie.showtimesQuickFilters.title,
			displayScrollArrows: true,
			displayOptions: {
				format: formats
			}
		};
	}
}

const quickFiltersFormatOrder = ['2D', '3D', 'IMAX', '4DX', 'IMAX 3D', 'ScreenX', 'D-BOX', 'D-Box 3D'].reverse();

function sortQuickFiltersFormat(formatOptions = {}) {
	return Object.keys(formatOptions).filter(((key) => !!formatOptions[key])).sort((a, b) => {
		const indexA = quickFiltersFormatOrder.indexOf(a);
		const indexB = quickFiltersFormatOrder.indexOf(b);
		return indexB - indexA;
	});
}

export function getShowtimesData() {
	return {
		boundingRegions: {
			gb: true,
			gg: true,
			ie: true,
			im: true,
			je: true,
		},
		cta: {
			1: '',
			2: '$COMING_SOON',
			3: '$SOLD_OUT',
			4: '$GET_TICKETS'
		},
		formatsDict: {
			'2D-35mm': '35mm',
			'2D-4DX': '4DX',
			'2D-4DX-DUBBED': '4DX Dubbed',
			'2D-4DX-SCREEN': '4DX Screen',
			'2D-70mm': '70mm',
			'2D-ATMOS': 'Dolby Atmos',
			'2D-CC': 'CC',
			'2D-DBOX': 'D-BOX',
			'2D-DBOX-DUBBED': 'D-BOX Dubbed',
			'2D-DELUXE': 'Deluxe',
			'2D-DUBBED': 'Dubbed',
			'2D-ENCORE': 'ENCORE',
			'2D-IMAX': 'IMAX',
			'2D-IMAX-70mm': 'IMAX 70mm',
			'2D-IMAX-CC': 'IMAX CC',
			'2D-IMAX-DUBBED': 'IMAX Dubbed',
			'2D-ISENSE': 'iSense',
			'2D-LIVE': 'Live',
			'2D-MARATHON': 'Marathon',
			'2D-MEGA': 'MEGA',
			'2D-PREVIEW': 'Preview',
			'2D-REALD': 'RealD',
			'2D-SCREENX': 'ScreenX',
			'2D-SING': 'Sing-a-long',
			'2D-SUBBED': 'Subtitled',
			'2D-VMAX': 'V-Max',
			'2D-XD': 'XD',
			'2D-XD-DUBBED': 'XD Dubbed',
			'2D-XD-SUBBED': 'XD Subtitled',
			'2D-XE': 'XE',
			'3D-4DX': '4DX',
			'3D-ATMOS': 'Dolby Atmos 3D',
			'3D-CC': '3D CC',
			'3D-DBOX': 'D-Box 3D',
			'3D-DELUXE': 'Deluxe 3D',
			'3D-IMAX': 'IMAX 3D',
			'3D-ISENSE': 'iSense 3D',
			'3D-MARATHON': 'Marathon 3D',
			'3D-MEGA': 'MEGA 3D',
			'3D-MX4D': 'MX4D 3D',
			'3D-REALD': 'RealD 3D',
			'3D-REALD-CC': '3D REALD CC',
			'3D-SCREENX': '3D ScreenX',
			'3D-SING': '3D Sing-a-long',
			'3D-VMAX': 'V-Max 3D',
			'3D-XD': 'XD 3D',
			'3D-XE': 'XE 3D',
			MX4D: 'MX4D',
			'MX4D-DUBBED': 'MX 4D Dubbed',
			priorityRepeatedTimes: ''
		},
		noShowtimes: {
			buttons: { filtersButton: true },
		},
		orderForFiltersAndScreenings: {
			format: [
				'IMAX 70mm',
				'IMAX 3D',
				'MX4D 3D',
				'MX 4D Dubbed',
				'4DX',
				'3D ScreenX',
				'XD 3D',
				'D-Box 3D',
				'iSense 3D',
				'RealD 3D',
				'V-Max 3D',
				'MEGA 3D',
				'Deluxe 3D',
				'Marathon 3D',
				'XE 3D',
				'3D Sing-a-long',
				'3D',
				'MX4D',
				'IMAX',
				'IMAX Dubbed',
				'4DX',
				'4DX Screen',
				'4DX Dubbed',
				'ScreenX',
				'XD',
				'XD Dubbed',
				'XD Subtitled',
				'XE',
				'Dolby Cinema',
				'Dolby Atmos',
				'Dolby',
				'RealD',
				'Preview',
				'V-Max',
				'D-BOX',
				'D-BOX Dubbed',
				'Deluxe',
				'iSense',
				'70mm',
				'35mm MEGA',
				'Marathon',
				'Live',
				'Sing-a-long',
				'2D',
				'Standard',
				'ENCORE',
				'Subtitled',
				'Dubbed',
			],
		},
		providers: {
			deeplink: 'odeon, vue, webedia, pow',
			showtimes: 'odeon, vue, webedia, pow',
			fandangoAffiliateID: '13180',
		},
		searchInputAriaLabel: '$SEARCH_FIELD_ARIA',
		clockFormat: '24',
		theaterDistanceUnit: 'km',
		theaterLocalisation: 'intl',
		useV2: true,
		screeningCategories: {
			exclusions: {
				attributes: true,
				audioDetails: true,
				language: true,
				movieId: true,
			}
		},
		...currentShowtimesData,
	};
}